import { render, staticRenderFns } from "./asideMenu.vue?vue&type=template&id=7a226f61"
import script from "./asideMenu.vue?vue&type=script&lang=js"
export * from "./asideMenu.vue?vue&type=script&lang=js"
import style0 from "./asideMenu.vue?vue&type=style&index=0&id=7a226f61&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports